// extracted by mini-css-extract-plugin
module.exports = {"main_footer":"Footer_main_footer__3iH65","empty_title":"Footer_empty_title__3RGm_","social_menu":"Footer_social_menu__3EZkS"};